import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionVideoFeedbackComponent } from './components/question-video-feedback/question-video-feedback.component';
import { BehaviourTableComponent } from './components/behaviour-table/behaviour-table.component';
import { OrderModule } from 'ngx-order-pipe';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartistModule } from 'ng-chartist';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { DndModule } from 'ngx-drag-drop';
import { NgxTimerModule } from 'ngx-timer';
import { ChartsModule } from 'ng2-charts';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer'; 
import { AvatarModule } from 'ngx-avatar';
import { AfqComponent } from './components/exercise-elements/afq/afq.component';
import { QuickGuideComponent } from './components/exercise-elements/quick-guide/quick-guide.component';
import { AudioResponseComponent } from './components/exercise-elements/audio-response/audio-response.component';
import { BlanksComponent } from './components/exercise-elements/blanks/blanks.component';
import { DocResponseComponent } from './components/exercise-elements/doc-response/doc-response.component';
import { DualRatingComponent } from './components/exercise-elements/dual-rating/dual-rating.component';
import { EditorComponent } from './components/exercise-elements/editor/editor.component';
import { ExerciseHeaderComponent } from './components/exercise-elements/exercise-header/exercise-header.component';
import { ExerciseNavigationBarComponent } from './components/exercise-elements/exercise-navigation-bar/exercise-navigation-bar.component';
import { FixedEditorComponent } from './components/exercise-elements/fixed-editor/fixed-editor.component';
import { LikeDislikeComponent } from './components/exercise-elements/like-dislike/like-dislike.component';
import { McqComponent } from './components/exercise-elements/mcq/mcq.component';
import { TextImageMfqComponent } from './components/exercise-elements/mfq/types/text-image-mfq/text-image-mfq.component';
import { TextTextMfqComponent } from './components/exercise-elements/mfq/types/text-text-mfq/text-text-mfq.component';
import { MfqComponent } from './components/exercise-elements/mfq/mfq.component';
import { OptionSelectorComponent } from './components/exercise-elements/option-selector/option-selector.component';
import { OrqComponent } from './components/exercise-elements/orq/orq.component';
import { QuestionJwplayerComponent } from './components/exercise-elements/question-jwplayer/question-jwplayer.component';
import { RatingComponent } from './components/exercise-elements/rating/rating.component';
import { RowsfeedbackComponent } from './components/exercise-elements/rowsfeedback/rowsfeedback.component';
import { RtqComponent } from './components/exercise-elements/rtq/rtq.component';
import { SjtComponent } from './components/exercise-elements/sjt/sjt.component';
import { VideoResponseComponent } from './components/exercise-elements/video-response/video-response.component';
import { PreventScrollDirective } from './components/exercise-elements/prevent-scroll.directive';
import { ExerciseComponent } from './components/exercise/exercise.component';
import { ReportFeedbackComponent } from './components/report-feedback/report-feedback.component';
import { ExerciseContainerComponent } from './components/exercise-container/exercise-container.component';
import { ScoreFaqModalComponent } from './components/score-faq-modal/score-faq-modal.component';
import { ScoreFaqModalV2Component } from './components/score-faq-modal-v2/score-faq-modal-v2.component';
import { AwaitResponseComponent } from './components/exercise-states/await-response/await-response.component';
import { BeginExerciseComponent } from './components/exercise-states/begin-exercise/begin-exercise.component';
import { ExerciseInsightsComponent } from './components/exercise-states/exercise-insights/exercise-insights.component';
import { ExerciseResultComponent } from './components/exercise-states/exercise-result/exercise-result.component';
import { PrimerCompletionComponent } from './components/exercise-states/primer-completion/primer-completion.component';
import { UnansweredModalComponent } from './components/exercise-states/unanswered-modal/unanswered-modal.component';
import { CourseCompletedComponent } from './components/player-states/course-completed/course-completed.component';
import { CourseCompletionPopoverComponent } from './components/player-states/course-completion-popover/course-completion-popover.component';
import { CourseFeedbackFormComponent } from './components/player-states/course-feedback-form/course-feedback-form.component';
import { CourseProgressComponent } from './components/player-states/course-progress/course-progress.component';
import { ModuleCompletedComponent } from './components/player-states/module-completed/module-completed.component';
import { WebSpeechModule } from './components/web-speech/web-speech.module';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { StaticPlayerComponent } from './components/static-player/static-player.component';
import { FormateSecondsPipe } from './pipes/formate-seconds.pipe';
import { MediaTypePipe } from './pipes/mediaType.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TextFormatPipe } from './pipes/text-format.pipe';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProgramLoaderComponent } from './components/program-loader/program-loader.component';
import { CommonFeedbackComponent } from './components/common-feedback/common-feedback.component';
import { MasterclassThresholdModalComponent } from './components/masterclass-threshold-modal/masterclass-threshold-modal.component';
import { PopupModalComponent } from './components/popup-modal/popup-modal.component';
import { CommonLoaderComponent } from './components/common-loader/common-loader.component';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { OptionalItemPopoverComponent } from './components/optional-item-popover/optional-item-popover.component';
import { DashboardDescriptionModalComponent } from './components/dashboard-description-modal/dashboard-description-modal.component';
import { LeaderboardInformationModalComponent } from './components/leaderboard-information-modal/leaderboard-information-modal.component';
import { CourseLockScreenComponent } from './components/course-lock-screen/course-lock-screen.component';


@NgModule({
    declarations: [
        QuestionVideoFeedbackComponent,
        BehaviourTableComponent,
        QuickGuideComponent,
        AudioResponseComponent,
        AfqComponent,
        BlanksComponent,
        DocResponseComponent,
        DualRatingComponent,
        EditorComponent,
        ExerciseHeaderComponent,
        ExerciseNavigationBarComponent,
        FixedEditorComponent,
        LikeDislikeComponent,
        McqComponent,
        TextImageMfqComponent,
        TextTextMfqComponent,
        MfqComponent,
        OptionSelectorComponent,
        OrqComponent,
        QuestionJwplayerComponent,
        RatingComponent,
        RowsfeedbackComponent,
        RtqComponent,
        SjtComponent,
        VideoResponseComponent,
        PreventScrollDirective,
        ExerciseComponent,
        ReportFeedbackComponent,
        ExerciseContainerComponent,
        ScoreFaqModalComponent,
        ScoreFaqModalV2Component,
        AwaitResponseComponent,
        BeginExerciseComponent,
        ExerciseInsightsComponent,
        ExerciseResultComponent,
        PrimerCompletionComponent,
        UnansweredModalComponent,
        CourseCompletedComponent,
        CourseCompletionPopoverComponent,
        CourseFeedbackFormComponent,
        CourseProgressComponent,
        ModuleCompletedComponent,
        StaticPlayerComponent,
        FormateSecondsPipe,
        MediaTypePipe,
        SafeHtmlPipe,
        TextFormatPipe,
        ProgramLoaderComponent,
        CommonFeedbackComponent,
        MasterclassThresholdModalComponent,
        PopupModalComponent,
        CommonLoaderComponent,
        TextEditorComponent,
        OptionalItemPopoverComponent,
        DashboardDescriptionModalComponent,
        LeaderboardInformationModalComponent,
        CourseLockScreenComponent
    ],
    imports: [
        CommonModule,
        FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(),
        OrderModule,
        RouterModule,
        FormsModule,
        ChartistModule,
        ImageCropperModule,
        DeviceDetectorModule.forRoot(),
        NgCircleProgressModule.forRoot({
            "radius": 25,
            "space": -2,
            "unitsColor": "#f47920",
            "titleColor": "#f47920",
            "outerStrokeWidth": 2,
            "outerStrokeColor": "#f47920",
            "innerStrokeColor": "#f0ccb9",
            "innerStrokeWidth": 2,
            "titleFontSize": "14",
            "subtitleFontSize": "14",
            "animateTitle": false,
            "animationDuration": 1000,
            "showTitle": true,
            "showUnits": true,
            "unitsFontSize": "14",
            "showBackground": false,
            "clockwise": true,
            "startFromZero": true,
            "showSubtitle": false,
        }),
        FilterPipeModule,
        NgbModule,
        ToastrModule,
        ReactiveFormsModule,
        ScrollToModule.forRoot(),
        DndModule,
        NgxTimerModule,
        ChartsModule,
        // NgxJsonLdModule,
        PdfJsViewerModule,
        AvatarModule,
        WebSpeechModule,
        SlickCarouselModule
    ],
    exports: [
        BehaviourTableComponent,
        AvatarModule,
        QuickGuideComponent,
        BlanksComponent,
        EditorComponent,
        ExerciseHeaderComponent,
        McqComponent,
        OrqComponent,
        RatingComponent,
        OptionSelectorComponent,
        ExerciseComponent,
        ReportFeedbackComponent,
        ExerciseContainerComponent,
        AwaitResponseComponent,
        BeginExerciseComponent,
        ExerciseInsightsComponent,
        ExerciseResultComponent,
        PrimerCompletionComponent,
        UnansweredModalComponent,
        CourseCompletedComponent,
        CourseFeedbackFormComponent,
        CourseProgressComponent,
        ModuleCompletedComponent,
        StaticPlayerComponent,
        FormateSecondsPipe,
        MediaTypePipe,
        SafeHtmlPipe,
        TextFormatPipe,
        ProgramLoaderComponent,
        CommonFeedbackComponent,
        MasterclassThresholdModalComponent,
        NgbModalModule,
        PopupModalComponent,
        CommonLoaderComponent,
        TextEditorComponent,
        OptionalItemPopoverComponent,
        DashboardDescriptionModalComponent,
        LeaderboardInformationModalComponent,
        CourseLockScreenComponent
    ]
})
export class SharedModule { }
